module.exports = __webpack_public_path__ + "img/i_main_icon_04.060f33ba.svg";